import { Typography, Grid, Avatar, Box, Divider, Paper, Chip, Tabs, Tab, IconButton } from "@mui/material";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import { useEffect, useState } from "react";
import { userServices } from "../../services/AllServices";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import errorHandler from "../../utils/errorHandler";
import { useNavigate, useParams } from "react-router-dom";
import Loader from "../../components/CustomLoader";
import { IMAGE_BASE } from "../../utils/constants";

const ViewUser = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [tabIndex, setTabIndex] = useState(0);
  const [albumTabIndex, setAlbumTabIndex] = useState(0); // New state for album sub-tabs
  const { id } = useParams();
  const navigate = useNavigate();
  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await userServices.getById({ id });
        setData(response.data.data);
      } catch (error) {
        errorHandler(error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [id]);

  if (loading) return <Loader />;
  if (!data) return <Typography variant="h6">No Data Found</Typography>;

  const UserChartersticks = data?.UserChartersticks || {};
  const { country, aboutMe, interests, membership, league, leval, albums } = UserChartersticks;

  return (
    <Box p={3} display="flex" gap={3}>
      <Paper elevation={3} sx={{ p: 3, borderRadius: 2, flex: 3 }}>
        <IconButton onClick={() => navigate(-1)} sx={{ mb: 2 }}>
          <ArrowBackIcon />
        </IconButton>
        <Grid container spacing={3} alignItems="center">
          <Grid item>
            <Avatar
              src={IMAGE_BASE + UserChartersticks?.profilePhoto}
              sx={{ width: 120, height: 120, border: "3px solid #1976d2" }}
            />
          </Grid>
          <Grid item>
            <Typography variant="h4" fontWeight="bold">{data?.username || "N/A"}</Typography>
            <Typography variant="body1" color="textSecondary"><b>Email : </b>{data?.email || "N/A"}</Typography>
            <Typography variant="body2"><b>Phone :</b> {data?.phoneNumber || "N/A"}</Typography>
            <Typography variant="body2"><b>Country :</b> {country || "N/A"}</Typography>
            <Chip label={data?.status === 1 ? "Active" : "Inactive"} color={data?.status === 1 ? "success" : "default"} />
          </Grid>
        </Grid>

        {/* Main Tabs */}
        <Tabs value={tabIndex} onChange={(e, newValue) => setTabIndex(newValue)} sx={{ mt: 2 }}>
          <Tab label="Personal Data" />
          <Tab label="Albums" />
        </Tabs>
        <Divider sx={{ my: 2 }} />

        {/* Tab Content */}
        {tabIndex === 0 && (

          <TableContainer component={Paper} sx={{ maxWidth: "650px" }}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell colSpan={3}><b>Personal Data</b></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow><TableCell><b>Level</b></TableCell><TableCell>:</TableCell><TableCell>{leval || "N/A"}</TableCell></TableRow>
                <TableRow><TableCell><b>League</b></TableCell><TableCell>:</TableCell><TableCell>{league || "N/A"}</TableCell></TableRow>
                <TableRow><TableCell><b>Country</b></TableCell><TableCell>:</TableCell><TableCell>{country || "N/A"}</TableCell></TableRow>
                <TableRow><TableCell><b>Interests</b></TableCell><TableCell>:</TableCell><TableCell>{interests?.length > 0 ? interests.join(", ") : "N/A"}</TableCell></TableRow>
                <TableRow><TableCell><b>Membership</b></TableCell><TableCell>:</TableCell><TableCell>{membership || "N/A"}</TableCell></TableRow>
                <TableRow><TableCell><b>About Me</b></TableCell><TableCell>:</TableCell><TableCell>{aboutMe || "N/A"}</TableCell></TableRow>

              </TableBody>
            </Table>
          </TableContainer>

        )}

        {tabIndex === 1 && (
          <>
            {albums && albums.length > 0 ? (
              <>
                <Tabs value={albumTabIndex} onChange={(e, newValue) => setAlbumTabIndex(newValue)} sx={{ mt: 2 }} className="customTabClass">
                  {albums.map((album, index) => (
                    <Tab key={album._id} label={`${album.albumName} Albums`} />
                  ))}
                </Tabs>
                <Divider sx={{ my: 2 }} />

                <Box sx={{ mt: 2 }}>
                  {albums.map((album, index) =>
                    albumTabIndex === index ? (
                      <Box key={album._id} sx={{ border: "1px solid #ccc", p: 2, borderRadius: 2 }}>
                        <Grid container spacing={2}>
                          {album.images && album.images.length > 0 ? (
                            album.images.map((img) => (
                              <Grid item key={img._id}>
                                <img
                                  src={IMAGE_BASE + img.src}
                                  alt={album.albumName}
                                  width={100}
                                  height={100}
                                  style={{ borderRadius: 8, objectFit: "cover", border: "1px solid #ddd" }}
                                />
                              </Grid>
                            ))
                          ) : (
                            <Typography>No Images Available</Typography>
                          )}
                        </Grid>
                      </Box>
                    ) : null
                  )}
                </Box>
              </>
            ) : (
              <Typography>No Albums Available</Typography>
            )}
          </>
        )}
      </Paper>
    </Box>
  );
};

export default ViewUser;